import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
  normalizePaged,
  type ListQueryParams,
  type Paged,
} from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { notificationEndpoints } from "@/features/notification/api/endpoints";
import type { NotificationTemplateDto } from "@/features/notification/api/dto";

/**
 * Liste paginée des modèles de notification
 * (`GET /NotificationTemplates?page=&pageSize=`, guide §6.7 — réponse
 * `Paged`). Toutes langues/canaux confondus.
 * Rôles : flashpay-superadmin, flashpay-admin.
 */
export const useNotificationTemplates = (
  params: ListQueryParams = {},
  enabled = true
) => {
  const page = params.page ?? DEFAULT_PAGE;
  const pageSize = params.pageSize ?? DEFAULT_PAGE_SIZE;
  return useQuery({
    queryKey: QUERY_KEYS.NOTIFICATION_TEMPLATES_LIST({
      ...params,
      page,
      pageSize,
    }),
    queryFn: async () => {
      const data = await fetchDataGet<
        Paged<NotificationTemplateDto> | NotificationTemplateDto[]
      >({
        url: notificationEndpoints.templates.list,
        queryParams: {
          ...params.filters,
          page: String(page),
          pageSize: String(pageSize),
        },
      });
      return normalizePaged(data, pageSize);
    },
    enabled,
  });
};
